import axios from "axios";
import axiosInstance from "./axiosInstance";

class EntesFederativosApi {
  cancelTokens = {
    getEntesAcompanhaveis: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  // Catálogo do seletor: o estadual (só para nomear a opção estadual) e os
  // municípios publicados no Legisla.
  async getEntesAcompanhaveis() {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getEntesAcompanhaveis = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/entes_federativos_acompanhaveis`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getEntesAcompanhaveis = null;

    return data;
  }
}

export default EntesFederativosApi;
